module.exports = __webpack_public_path__ + "static/media/portfolio1 (35).85f63f51.jpeg";